import { useSelector } from 'react-redux';

import type { DocumentList } from '../../../@types/ElasticSearchResponse';
import type { ElasticVehicle } from '../../../@types/ElasticVehicle';
import type { FilterHistory } from '../../../@types/FilterHistory';
import type { SearchHistory } from '../../../@types/SearchHistory';
import QueryFilter from '../../../helpers/query-filter';
import type { RootState } from '../../../reducers';

const merge = (list: FilterHistory[]): SearchHistory[] => {
  const cache: { [key: string]: boolean } = {};

  return list
    .map((hit) => ({
      query: QueryFilter.create(hit.query)
        .removeAll(['page', 'offset', 'size', 'hits', 'sort'])
        .toString(),
      count: hit.count,
      createdAt: hit.createdAt,
    }))
    .filter((hit) => {
      if (cache[hit.query]) {
        return false;
      }

      cache[hit.query] = true;
      return true;
    });
};

const localStorageKey = 'wayke-filter-history';
const useHistory = (queryFilter?: QueryFilter) => {
  if (process.env.SSR) return [];
  const documentList = useSelector<RootState, DocumentList<ElasticVehicle> | null>(
    (s) => s.search.documentList,
  );
  const cleanQueryFilter =
    queryFilter && queryFilter.removeAll(['page', 'offset', 'size', 'hits', 'sort']);

  const query =
    cleanQueryFilter && !cleanQueryFilter.isEmpty() ? cleanQueryFilter.toString() : false;
  const persistance = merge(
    JSON.parse(localStorage.getItem(localStorageKey) || '[]') as FilterHistory[],
  );
  const index = persistance.findIndex((hit) => hit.query === query);

  if (documentList) {
    if (query && index < 0) {
      persistance.unshift({
        query,
        count: documentList.numberOfHits,
        createdAt: new Date().getTime(),
      });

      localStorage.setItem(localStorageKey, JSON.stringify(persistance.slice(0, 50)));
    } else if (query && index >= 0 && persistance[index].count !== documentList.numberOfHits) {
      persistance[index] = {
        query,
        count: documentList.numberOfHits,
        createdAt: new Date().getTime(),
      };

      localStorage.setItem(localStorageKey, JSON.stringify(persistance.slice(0, 50)));
    }
  }

  return persistance;
};

export default useHistory;
